import React, { useEffect, useState } from 'react'
import Modal1 from '../Modal1'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { db } from '../../../../../firebase';


function Menuinfo({ menuName, menuCategories, rating, menuAvailability, menuId, branchId, restId, createdById, mealImage }) {
    const [branch, setBranch] = useState()
    const [menu, setMenu] = useState()
    const [res, setRes] = useState()
    const [creator, setCreator] = useState()

    useEffect(() => {
      db.collection('branches').doc(`${branchId}`).onSnapshot((doc) => {
        setBranch(doc.data());
      });
  }, [])
  useEffect(() => {
    db.collection('menus').doc(`${menuId}`).onSnapshot((doc) => {
        setMenu(doc.data());
    });
}, [])
useEffect(() => {
    db.collection('restaurants').doc(`${restId}`).onSnapshot((doc) => {
        setRes(doc.data());
    });
}, [])

useEffect(() => {
    db.collection('traders').doc(`${createdById}`).onSnapshot((doc) => {
        setCreator(doc.data());
    });
}, [])

  return (
    <div>
               <div>
            <div className="modal-body">
            <div className="row align-items-center">
                
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="">
                {/* <img src={mealImage} style={{objectFit:'contain'}} className="img-fluid" alt="" /> */}
                <Modal1 mealImage={mealImage} />
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="woo_pr_detail">
                  <div className="woo_cats_wrps">
                    <a href="#" className="woo_pr_cats">{menuName}, ({branch?.branch})</a>
                    <span className="woo_pr_trending">
                        {menuAvailability === true ?(
                            <span>Available</span>
                        ):(
                            <span>Unavailable</span>
                        )}
                    </span>
                  </div>
                   <h6 className="woo_pr_title">{branch?.branchAddress}</h6>

                  <Paper sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableBody>
          <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Menu Category</span> 
              </TableCell>
              <TableCell >
                    {!menu?.menuCategories ?(
                        <>N/A</>
                    ):(
                        <>
                         {menuCategories.map(items =>(
                          <span style={{marginLeft:3,fontWeight:'bold'}}>{items}</span>
                        ))}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Restaurant</span> 
              </TableCell>
              <TableCell >
              {!res?.restaurant ?(
                        <>N/A</>
                    ):(
                        <>
                        {res?.restaurant}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>              
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Branch Name</span> 
              </TableCell>
              <TableCell >
                    {!branch?.branch ?(
                        <>N/A</>
                    ):(
                        <>
                        {branch?.branch}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>              
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Branch Address</span> 
              </TableCell>
              <TableCell >
                    {!branch?.branchAddress ?(
                        <>N/A</>
                    ):(
                        <>
                        {branch?.branchAddress}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Creator Name</span> 
              </TableCell>
              <TableCell >
                    {!creator?.createdByName ?(
                        <>N/A</>
                    ):(
                        <>
                        {creator?.createdByName}
                        </>
                    )} 
              </TableCell>
          </TableRow>

          {/* <TableRow>
          <TableCell >
                   <span style={{fontWeight:'bold'}}>Creator Email</span> 
              </TableCell>
              <TableCell >
                    {!creator?.createdByEmail ?(
                        <>N/A</>
                    ):(
                        <>
                        {creator?.createdByEmail}
                        </>
                    )} 
              </TableCell>
          </TableRow> */}


          </TableBody>
        </Table>
      </TableContainer>

    </Paper>
                </div>
              </div>
            </div>
          </div>

            </div> 
    </div>
  )
}

export default Menuinfo